import { stopAsyncValidation } from 'redux-form'
import { all, call, put, take, takeLatest } from 'redux-saga/effects'
import { callFetch } from '../../actions/fetch'
import { IValidateDateTime } from '../../actions/userObject/settings/dateTimeFormat'
import i18n from '../../i18n'
import validateDateTime from '../../models/Misc/checkDateTime'
import { DateTimeFormatActions } from '../../reducers/userObject/actionNames'
import { ActionNames } from '../../utils/FetchActionsName'
import fetchActionsName from '../../utils/FetchActionsName/fetchActionsName'

function* validateSettingsForm(action: IValidateDateTime) {
  try {
    const actionNames = fetchActionsName(ActionNames.ValidateDate)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, validateDateTime)),
    ])

    yield call(service, action.dateFormat, action.timeFormat)
    yield put(stopAsyncValidation('settings', {}))
  } catch (e) {
    yield put(
      stopAsyncValidation('settings', {
        dateFormat: i18n.t(e.message),
        hourFormat: i18n.t(e.message),
      }),
    )
  }
}

export default function* () {
  yield takeLatest(
    DateTimeFormatActions.ValidateDateTimeFormatValues,
    validateSettingsForm,
  )
}
